import { render } from "./persistentvolumeclaim.vue?vue&type=template&id=73debbd0"
import script from "./persistentvolumeclaim.vue?vue&type=script&lang=js"
export * from "./persistentvolumeclaim.vue?vue&type=script&lang=js"

import exportComponent from "../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__